import { useTheme } from '@mui/material';

import { Icons, SxProps, ExternalLink, Typography } from '@cast/design-system';

import { CloseableAlert } from 'components/alerts';

import { EXTERNAL_LINKS } from '@cast/constants';

type Props = {
  sx?: SxProps;
};

export const EksControlPlaneCostsAlert = ({ sx }: Props) => {
  const { palette } = useTheme();

  return (
    <CloseableAlert
      title="The costs of running an outdated control plane have increased sixfold"
      color="advisory"
      size="sm"
      icon={<Icons.Warning color={palette.red[500]} />}
      sx={sx}
      closeable
      testId="control-plane-costs-alert"
    >
      <Typography variant="P12R">
        EKS clusters running Kubernetes versions within the extended support
        window are charged $0.60 per cluster per hour for the control plane,
        instead of $0.10.{' '}
        <ExternalLink
          sx={{ typography: 'P12M' }}
          link={EXTERNAL_LINKS.external_docs_eks_control_plane_costs}
          noIcon
        >
          Learn more
        </ExternalLink>
      </Typography>
    </CloseableAlert>
  );
};
